<script lang="ts">
  import { isInternalUser } from "@/stores/authStore"
  import { isDev } from "@/util"
</script>

{#if $isInternalUser || isDev()}
  <slot />
{/if}
